// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const dewgong: PokeData = {
  "id": 87,
  "name": "dewgong",
  "height": 17,
  "weight": 1200,
  "base_experience": 166,
  "types": [
    PokeType.WATER,
    PokeType.ICE
  ],
  "api_moves": [
    "headbutt",
    "horn-drill",
    "take-down",
    "double-edge",
    "growl",
    "water-gun",
    "ice-beam",
    "bubble-beam",
    "aurora-beam",
    "waterfall",
    "rest",
    "icy-wind",
    "safeguard",
    "encore",
    "fake-out",
    "hail",
    "dive",
    "signal-beam",
    "sheer-cold",
    "brine",
    "aqua-ring",
    "aqua-tail",
    "ice-shard",
    "aqua-jet",
    "snowscape"
  ],
  "moves": [
    "headbutt",
    "growl",
    "bubble-beam",
    "sheer-cold",
    "brine",
    "aqua-tail",
    "ice-shard",
    "aqua-jet",
    "icicle-dagger",
    "rain-dance",
    "ice-wave",
    "aqua-cutter",
    "hydro-pump"
  ],
  "evolution_chain": {
    "id": 37,
    "item": null,
    "species": [
      {
        "name": "seel",
        "order": 94,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dewgong",
        "order": 95,
        "types": [
          PokeType.WATER,
          PokeType.ICE
        ],
        "evolves_from_species_id": 86,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 155,
    "speed": 122,
    "ability_power": 122
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
